import type { MockLeaderboardEntry } from './types';
import { mockAthletes } from './athletes';

export const mockLeaderboardTeam: MockLeaderboardEntry[] = mockAthletes.slice(0, 15).map((a, i) => ({
    rank: i + 1,
    athleteId: a.id,
    name: `${a.firstName} ${a.lastName}`,
    teamId: a.teamId,
    teamName: 'Heaven Due Nuoto',
    points: 2800 - i * 80 - ((i * 7) % 30),
    delta: i === 0 ? 0 : i % 3 === 0 ? 2 : i % 4 === 0 ? -1 : 1
}));

const globalTeams = [
    'Polisportiva Tiburtina',
    'Aurelia Nuoto',
    'Heaven Due Nuoto',
    'GAM Team Swimming',
    'Circolo Canottieri Aniene',
    'SS Lazio Nuoto'
];

export const mockLeaderboardGlobal: MockLeaderboardEntry[] = Array.from({ length: 50 }, (_, i) => ({
    rank: i + 1,
    athleteId: `athlete-g-${i + 1}`,
    name: `${['Matteo', 'Sofia', 'Alessandro', 'Giulia', 'Marco', 'Chiara'][i % 6]} ${['Bianchi', 'Rossi', 'Ferrari', 'Verdi', 'Conti'][i % 5]}`,
    teamId: `team-g-${(i % 6) + 1}`,
    teamName: globalTeams[i % 6],
    points: 3200 - i * 45 - ((i * 11) % 25),
    delta: i % 5 === 0 ? 3 : i % 3 === 0 ? -2 : 1
}));
